import DGReviewCollectionGeneric from 'client/store/modules/collections/DGReviewCollectionGeneric';
import SystemApi from 'client/api/v2/SystemApi';
import SystemGroupApi from 'client/api/v2/SystemGroupApi';

export default new DGReviewCollectionGeneric(SystemApi, SystemGroupApi, '_id', 'displayName').extractModule();
